import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core'
import {ContentSectionComponent} from '../../../../craft/content-section/content-section.component'
import {TeaserCardComponent} from '../../../../craft/cards/teaser-card/teaser-card.component'
import {TeaserCardTitleComponent} from '../../../../craft/cards/teaser-card/teaser-card-title/teaser-card-title.component'
import {RouterLink} from '@angular/router'
import {RelatedArticlesSection_SearchArticlesGql} from '../../../../../__generated__/types'
import {AsyncPipe} from '@angular/common'
import {map} from 'rxjs/operators'
import {pickProperty} from '../../../../core/graphql/graphql-utils'
import {parseArticlePreview} from '../../../../core/content/serde/article-page.serde'
import {LinkService} from '../../../../core/i18n/link.service'
import {RelatedArticlesSection} from '../../../../core/content/types/related-articles-section.types'

@Component({
  selector: 'bgo-related-articles-section',
  templateUrl: './related-articles-section.component.html',
  styles: `
    @reference '../../../../../styles/app-reference.css';

    :host {
      @apply block;
      @apply last:!mb-3xl;
    }
  `,
  host: {'[class.h-content-layout]': 'true'},
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ContentSectionComponent, TeaserCardComponent, TeaserCardTitleComponent, RouterLink, AsyncPipe],
})
export class RelatedArticlesSectionComponent {
  section = input.required<RelatedArticlesSection>()
  articles$ = computed(() => {
    const section = this.section()
    return this.searchArticles
      .fetch({
        topics: section.relatedTopics,
        page: {
          limit: section.maxArticles || 4,
        },
      })
      .pipe(
        map(res => pickProperty(res.data, 'searchArticles')),
        map(articles => articles.items.map(article => parseArticlePreview(article, this.linkService))),
      )
  })

  constructor(
    private readonly searchArticles: RelatedArticlesSection_SearchArticlesGql,
    private readonly linkService: LinkService,
  ) {}
}
